import type { ReactNode } from "react"
import cn from "@/v2-ui/utils/utils.cn"

export type StatusStickyNavProps = {
  children: ReactNode
}

// Sticky wrapper for the page's primary platform-filter pill row.
// Pins to the top of the viewport so the customer always has a
// one-click platform switcher in reach — short pages don't need it
// stuck, but the per-platform detail view (with the accordion
// stack) easily scrolls past the first viewport.
//
// The wrapper carries the sticky positioning and the shared chrome
// (bottom border, blurred background) so the inner nav stays
// layout-agnostic. The secondary "category jumps" row that used to
// stack inside this wrapper has moved into the per-platform
// sidebar; this component is now a single tier and intentionally
// keeps its name as `StatusStickyNav` because it remains the only
// nav glued to the top of the page.
function StatusStickyNav(props: Readonly<StatusStickyNavProps>) {
  const { children } = props
  return (
    <div
      className={cn(
        // -mx + px lets the bar bleed out to the edges of the
        // page container so the divider runs full-width while the
        // pill content stays aligned with the rest of the page.
        "sticky top-0 z-30 -mx-2 px-2 sm:-mx-4 sm:px-4",
        "border-b border-border/60 bg-background/50 backdrop-blur",
      )}
    >
      {children}
    </div>
  )
}

export default StatusStickyNav
